module.exports = __webpack_public_path__ + "img/2.57063393.svg";